import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";
import useAuthCheck from "./hooks/useAuthCheck";
import Conversation from "./pages/Team";
import Inbox from "./pages/Project";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Project from "./pages/Project";
import Team from "./pages/Team";

function App() {
    const authChecked = useAuthCheck();

    return !authChecked ? (
        <div>Checking authentication....</div>
    ) : (
        <Router>
            <Routes>
                <Route
                    path="/"
                    element={
                        <PublicRoute>
                            <Login />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/register"
                    element={
                        <PublicRoute>
                            <Register />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/projects"
                    element={
                        <PrivateRoute>
                            <Project />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/teams"
                    element={
                        <PrivateRoute>
                            <Team />
                        </PrivateRoute>
                    }
                />
            </Routes>
        </Router>
    );
}

export default App;
